import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getSupporterCode } from "@/lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [stats, setStats] = useState(null);
  const [unlocked, setUnlocked] = useState(!!getSupporterCode());

  const refresh = useCallback(async () => {
    try {
      const [s, st] = await Promise.all([api.get("/settings/public"), api.get("/stats")]);
      setSettings(s.data);
      setStats(st.data);
    } catch (e) {
      /* site still renders without live stats */
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const handler = () => setUnlocked(!!getSupporterCode());
    window.addEventListener("technow:unlock", handler);
    return () => window.removeEventListener("technow:unlock", handler);
  }, []);

  return (
    <SiteCtx.Provider value={{ settings, stats, unlocked, setUnlocked, refresh }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
